import { c as _c } from "react/compiler-runtime";
import axios from 'shared/anaxios';
import { FORM_ERROR } from 'final-form';
import { DateTime } from 'luxon';
import React from 'react';
import { Field, Form } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import Button from 'shared/button';
import EmptyState from 'shared/empty-state';
import { Flex } from 'shared/grid';
import Label from 'shared/label';
import Loader from 'shared/loader';
import { StandardModal } from 'shared/modal';
import { fetchBooking, patchBooking } from 'shared/redux/bookings/actions';
import { LOGIN_SUCCEEDED } from 'shared/redux/session/action-types';
import settings from 'shared/settings';
import Textarea from 'shared/textarea';
import { addToast } from 'shared/toaster/redux/actions';
import { getScrollToErrors } from 'shared/utils/form';
import { Booking } from 'shared/utils/time';
import { useAppDispatch, useAppSelector } from '../../store';
import PayView from './pay';
import DefaultView from './view';
import { useParams, useSearchParams } from 'react-router-dom';
const BookingView = () => {
  const $ = _c(56);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const [showCancelModal, setShowCancelModal] = React.useState(false);
  const {
    bookingId
  } = useParams();
  const business = useAppSelector(_temp);
  let t0;
  if ($[0] !== bookingId) {
    t0 = state_0 => (state_0.session.bookingIds || []).includes(bookingId);
    $[0] = bookingId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isOwner = useAppSelector(t0);
  let t1;
  if ($[2] !== bookingId) {
    t1 = state_1 => state_1.bookings.data[bookingId];
    $[2] = bookingId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const booking = useAppSelector(t1);
  let t2;
  if ($[4] !== booking) {
    t2 = state_2 => booking ? state_2.locations.data[booking.location_id] : null;
    $[4] = booking;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const bookingLocation = useAppSelector(t2);
  let t3;
  if ($[6] !== booking || $[7] !== business || $[8] !== isOwner) {
    t3 = isOwner && booking && booking.services.every(_temp2) && ["confirmed", "requested", "pencilled_in", "awaiting_payment"].includes(booking.status) && !business.settings.disable_changes;
    $[6] = booking;
    $[7] = business;
    $[8] = isOwner;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const canCancel = t3;
  let t4;
  if ($[10] !== bookingLocation) {
    t4 = bookingLocation || {
      timezone: DateTime.local().zoneName,
      address: ""
    };
    $[10] = bookingLocation;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const location = t4;
  let t5;
  if ($[12] !== searchParams) {
    t5 = searchParams.get("c");
    $[12] = searchParams;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const code = t5;
  const isLoading = useAppSelector(_temp4);
  let t6;
  let t7;
  if ($[14] !== booking || $[15] !== bookingId || $[16] !== dispatch) {
    t6 = () => {
      if (!booking && bookingId) {
        dispatch(fetchBooking(bookingId));
      }
    };
    t7 = [booking, bookingId, dispatch];
    $[14] = booking;
    $[15] = bookingId;
    $[16] = dispatch;
    $[17] = t6;
    $[18] = t7;
  } else {
    t6 = $[17];
    t7 = $[18];
  }
  React.useEffect(t6, t7);
  let t8;
  let t9;
  if ($[19] !== booking || $[20] !== bookingId || $[21] !== code || $[22] !== dispatch) {
    t8 = () => {
      if (code && code !== "xxxx" && booking) {
        axios.post(`${settings.api2Root}/token-booking`, {
          booking_id: bookingId,
          code
        }, {
          skipErrorReportOnCode: {
            "401": true
          }
        }).then(t10 => {
          const {
            data
          } = t10;
          if (!data) {
            return;
          }
          dispatch({
            type: LOGIN_SUCCEEDED,
            payload: data
          });
        });
      }
    };
    t9 = [booking, bookingId, code, dispatch];
    $[19] = booking;
    $[20] = bookingId;
    $[21] = code;
    $[22] = dispatch;
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  React.useEffect(t8, t9);
  let t10;
  if ($[25] !== setSearchParams) {
    t10 = lid => {
      setSearchParams(prev => ({
        ...Object.fromEntries(prev.entries()),
        lid: lid || undefined
      }), {
        replace: true
      });
    };
    $[25] = setSearchParams;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const ensureLocationIdIsSet = t10;
  let t11;
  let t12;
  if ($[27] !== booking || $[28] !== ensureLocationIdIsSet) {
    t11 = () => {
      if (booking) {
        ensureLocationIdIsSet(booking.location_id);
      }
    };
    t12 = [booking, ensureLocationIdIsSet];
    $[27] = booking;
    $[28] = ensureLocationIdIsSet;
    $[29] = t11;
    $[30] = t12;
  } else {
    t11 = $[29];
    t12 = $[30];
  }
  React.useEffect(t11, t12);
  const [wasLoaded, setWasLoaded] = React.useState(false);
  let t13;
  let t14;
  if ($[31] !== isLoading) {
    t13 = () => {
      if (!isLoading) {
        setWasLoaded(true);
      }
    };
    t14 = [isLoading];
    $[31] = isLoading;
    $[32] = t13;
    $[33] = t14;
  } else {
    t13 = $[32];
    t14 = $[33];
  }
  React.useEffect(t13, t14);
  let t15;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [getScrollToErrors()];
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const decorators = t15;
  let t16;
  if ($[35] !== dispatch) {
    t16 = (bookingId_0, reason) => dispatch(patchBooking({
      id: bookingId_0,
      status: "cancelled",
      reason
    })).then(() => {
      dispatch(addToast("Booking cancelled", "success"));
      ;
      try {
        const event = {
          event: "booking_cancelled",
          booking_id: bookingId_0
        };
        if (window.dataLayer) {
          window.dataLayer.push(event);
        } else {
          if (window.gtag) {
            window.gtag("event", "booking_cancelled");
          } else {
            if (window.ga) {
              window.ga("send", "event", "booking", "cancelled");
            }
          }
        }
      } catch (t17) {
        const e = t17;
        console.error(e);
        Sentry.captureException(e);
      }
    });
    $[35] = dispatch;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const cancelBooking = t16;
  if (isLoading && !wasLoaded) {
    let t17;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Loader />;
      $[37] = t17;
    } else {
      t17 = $[37];
    }
    return t17;
  }
  if (!booking) {
    let t17;
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <EmptyState heading="Booking not found" />;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    return t17;
  }
  let t17;
  if ($[39] !== booking || $[40] !== canCancel || $[41] !== isOwner || $[42] !== location || $[43] !== showCancelModal) {
    t17 = booking?.status === "awaiting_payment" ? <PayView booking={booking} location={location} canCancel={canCancel} isOwner={isOwner} setShowCancelModal={setShowCancelModal} /> : <DefaultView booking={booking} location={location} canCancel={canCancel} isOwner={isOwner} setShowCancelModal={setShowCancelModal} showCancelModal={showCancelModal} />;
    $[39] = booking;
    $[40] = canCancel;
    $[41] = isOwner;
    $[42] = location;
    $[43] = showCancelModal;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  let t19;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => setShowCancelModal(false);
    t19 = <FormattedMessage id="Public.BookingPage.cancelConfirmModalHeading" defaultMessage="Are you sure you want to cancel?" />;
    $[45] = t18;
    $[46] = t19;
  } else {
    t18 = $[45];
    t19 = $[46];
  }
  let t20;
  if ($[47] !== bookingId || $[48] !== cancelBooking) {
    t20 = () => <Form decorators={decorators} onSubmit={values => cancelBooking(bookingId, values.reason).then(() => {
      setShowCancelModal(false);
    }).catch(_temp5)}>{t21 => {
        const {
          handleSubmit,
          submitting,
          values: values_0
        } = t21;
        return <form onSubmit={handleSubmit} noValidate={true}><Field name="reason">{_temp6}</Field><Flex justifyContent="flex-end" mt={3}><Button color="gray" variant="flat" mr={2} onClick={() => setShowCancelModal(false)}><FormattedMessage id="Back" defaultMessage="Back" /></Button><Button type="submit" disabled={!values_0.reason || submitting} loading={submitting}><FormattedMessage id="Cancel booking" defaultMessage="Cancel booking" /></Button></Flex></form>;
      }}</Form>;
    $[47] = bookingId;
    $[48] = cancelBooking;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== showCancelModal || $[51] !== t20) {
    t21 = <StandardModal isOpen={showCancelModal} close={t18} title={t19}>{t20}</StandardModal>;
    $[50] = showCancelModal;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t17 || $[54] !== t21) {
    t22 = <>{t17}{t21}</>;
    $[53] = t17;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  return t22;
};
export default BookingView;
function _temp(state) {
  return state.businesses.data[state.public.businessId];
}
function _temp2(s) {
  return s.start > DateTime.utc().toISO().substring(0, 19) + "Z";
}
function _temp3(v) {
  return v || "loading";
}
function _temp4(state_3) {
  return [state_3.businesses.status, state_3.locations.status, state_3.services.status, state_3.bookables.status, state_3.bookableGroups.status, state_3.bookableBusy.status, state_3.bookings.status].map(_temp3).includes("loading") || !state_3.public.businessId;
}
function _temp5(error) {
  if (error?.response?.status >= 500 || !error?.response?.data?.errors) {
    return;
  }
  return {
    [FORM_ERROR]: "Something went wrong"
  };
}
function _temp6(t0) {
  const {
    input
  } = t0;
  return <><Label mb={2} data-sentry-element="Label" data-sentry-source-file="component.tsx"><FormattedMessage id="Public.BookingPage.cancelConfirmModalReasonInputLabel" defaultMessage="Reason for cancelling" data-sentry-element="FormattedMessage" data-sentry-source-file="component.tsx" /></Label><Textarea {...input} data-sentry-element="Textarea" data-sentry-source-file="component.tsx" /></>;
}